import { AssetSchema, SystemType } from '@innovyze/lib_asset_schema';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';

interface AssetSchemaFF {
	[systemType: string]: boolean | string[];
}

export const useAssetSchemaFF = () => {
	const useNewSchema = useIsFeatureEnabled('info360-rehab-new-asset-types');

	let assetSchemaFF: AssetSchemaFF;
	// Needed to test the new schema
	if (useNewSchema) {
		assetSchemaFF = useIsFeatureEnabled(
			'i360-release-asset-schema',
		) as unknown as AssetSchemaFF;
	} else {
		assetSchemaFF = {
			SanitarySewer: ['wwPipe'],
			WaterDistribution: ['pipe'],
		};
	}

	const validSystemTypes = Object.keys(assetSchemaFF).filter(
		systemType =>
			assetSchemaFF[systemType] === true ||
			Array.isArray(assetSchemaFF[systemType]),
	);

	const allSystemTypesValid = validSystemTypes.length === 0;

	const isValidSystemType = (systemType: SystemType) =>
		validSystemTypes.includes(systemType.id) || allSystemTypesValid;

	const isValidAssetType = (assetType: AssetSchema) => {
		if (allSystemTypesValid) {
			return true;
		}
		const assetTypes = assetSchemaFF[assetType.systemType.id];
		if (assetTypes === true) {
			return true;
		}
		if (Array.isArray(assetTypes)) {
			return assetTypes.includes(assetType.id);
		}
		return false;
	};

	return {
		isValidSystemType,
		isValidAssetType,
	};
};
